import {css} from "@panda/css";

import {useFormContextRHF} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {PriceField} from "@/components/price_field/PriceField";

import {HOME_MATCH_PREFERENCES_SURVEY_FINANCING_OPTIONS} from "../../constants/preferences/home_match_preferences_survey_content";
import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "../../constants/preferences/home_match_preferences_wizard_content";
import {IHomeMatchPreferencesWizardSurveyForm} from "../../utils/get_home_match_preferences_wizard_step_patch";
import {HomeMatchPreferencesWizardFinancingOption} from "./HomeMatchPreferencesWizardFinancingOption";

const FINANCING_LABEL_ID = "home-match-preferences-wizard-financing-label";
const {BUDGET_LABEL, BUDGET_PLACEHOLDER, FINANCING} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;

export const HomeMatchPreferencesWizardBudgetStep = () => {
    const {isMobile} = useUserDevice();
    const {setValue, watch} = useFormContextRHF<IHomeMatchPreferencesWizardSurveyForm>();
    const financing = watch("financing");
    const priceUpper = watch("price.upper");

    return (
        <div className={stepStyle}>
            <div className={sliderStyle}>
                <Text color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                    {BUDGET_LABEL}
                </Text>

                <PriceField
                    classNames={{
                        amount: budgetAmountStyle,
                        field: budgetFieldStyle,
                        input: budgetAmountValueStyle,
                        inputWrap: budgetAmountWrapStyle,
                        inputWrapper: budgetAmountBoxStyle,
                        root: budgetPriceFieldStyle
                    }}
                    name="price.upper"
                    placeholder={isMobile ? undefined : BUDGET_PLACEHOLDER}
                    showPlaceholderAtMin={!isMobile}
                    value={priceUpper}
                />
            </div>

            <div className={financingStyle}>
                <Text className={labelStyle} color="var(--colors-gray-900)" id={FINANCING_LABEL_ID} preserveFontSize variant="body_copy_2">
                    {FINANCING.GROUP_LABEL}
                </Text>

                <div aria-labelledby={FINANCING_LABEL_ID} className={optionsStyle} role="radiogroup">
                    {HOME_MATCH_PREFERENCES_SURVEY_FINANCING_OPTIONS.map((option) => (
                        <HomeMatchPreferencesWizardFinancingOption
                            isSelected={financing === option.value}
                            key={option.value}
                            label={option.label}
                            onSelect={() => setValue("financing", option.value, {shouldDirty: true})}
                            value={option.value}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

const stepStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 3
});

const sliderStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1
});

const budgetPriceFieldStyle = css({
    display: "flex",
    flex: "none",
    flexDirection: "column",
    width: "100%"
});

const budgetFieldStyle = css({
    maxWidth: "100%",
    minWidth: 0,

    "& > div > div:first-child": {
        flex: "1 1 auto",
        minWidth: 0,
        px: 1.5
    }
});

const budgetAmountStyle = css({
    flex: "0 0 10.5rem",
    width: "10.5rem"
});

const budgetAmountBoxStyle = css({
    alignItems: "center",
    border: "1px solid var(--colors-gray-900)",
    height: "4.8rem",
    justifyContent: "flex-start",
    py: 0,
    width: "10.5rem"
});

const budgetAmountWrapStyle = css({
    flex: "0 0 auto",
    justifyContent: "flex-start",
    width: "auto"
});

const budgetAmountValueStyle = css({
    height: "auto",
    maxWidth: "100%",
    textAlign: "left",
    width: "100%"
});

const financingStyle = css({
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    gap: 1
});

const labelStyle = css({
    whiteSpace: "nowrap"
});

const optionsStyle = css({
    display: "flex",
    flexWrap: "wrap",
    gap: 1
});
import {css} from "@panda/css";

import {useFormContextRHF} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {PriceField} from "@/components/price_field/PriceField";

import {HOME_MATCH_PREFERENCES_SURVEY_FINANCING_OPTIONS} from "../../constants/preferences/home_match_preferences_survey_content";
import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "../../constants/preferences/home_match_preferences_wizard_content";
import {IHomeMatchPreferencesWizardSurveyForm} from "../../utils/get_home_match_preferences_wizard_step_patch";
import {HomeMatchPreferencesWizardFinancingOption} from "./HomeMatchPreferencesWizardFinancingOption";

const FINANCING_LABEL_ID = "home-match-preferences-wizard-financing-label";
const {BUDGET_LABEL, BUDGET_PLACEHOLDER, FINANCING} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;

export const HomeMatchPreferencesWizardBudgetStep = () => {
    const {isMobile} = useUserDevice();
    const {setValue, watch} = useFormContextRHF<IHomeMatchPreferencesWizardSurveyForm>();
    const financing = watch("financing");
    const priceUpper = watch("price.upper");

    return (
        <div className={stepStyle}>
            <div className={sliderStyle}>
                <Text color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                    {BUDGET_LABEL}
                </Text>

                <PriceField
                    classNames={{
                        amount: budgetAmountStyle,
                        field: budgetFieldStyle,
                        input: budgetAmountValueStyle,
                        inputWrap: budgetAmountWrapStyle,
                        inputWrapper: budgetAmountBoxStyle,
                        root: budgetPriceFieldStyle
                    }}
                    name="price.upper"
                    placeholder={isMobile ? undefined : BUDGET_PLACEHOLDER}
                    showPlaceholderAtMin={!isMobile}
                    value={priceUpper}
                />
            </div>

            <div className={financingStyle}>
                <Text className={labelStyle} color="var(--colors-gray-900)" id={FINANCING_LABEL_ID} preserveFontSize variant="body_copy_2">
                    {FINANCING.GROUP_LABEL}
                </Text>

                <div aria-labelledby={FINANCING_LABEL_ID} className={optionsStyle} role="radiogroup">
                    {HOME_MATCH_PREFERENCES_SURVEY_FINANCING_OPTIONS.map((option) => (
                        <HomeMatchPreferencesWizardFinancingOption
                            isSelected={financing === option.value}
                            key={option.value}
                            label={option.label}
                            onSelect={() => setValue("financing", option.value, {shouldDirty: true})}
                            value={option.value}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

const stepStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 3
});

const sliderStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1
});

const budgetPriceFieldStyle = css({
    display: "flex",
    flex: "none",
    flexDirection: "column",
    width: "100%"
});

const budgetFieldStyle = css({
    maxWidth: "100%",
    minWidth: 0,

    "& > div > div:first-child": {
        flex: "1 1 auto",
        minWidth: 0,
        px: 1.5
    }
});

const budgetAmountStyle = css({
    flex: "0 0 10.5rem",
    width: "10.5rem"
});

const budgetAmountBoxStyle = css({
    alignItems: "center",
    border: "1px solid var(--colors-gray-900)",
    height: "4.8rem",
    justifyContent: "flex-start",
    py: 0,
    width: "10.5rem"
});

const budgetAmountWrapStyle = css({
    flex: "0 0 auto",
    justifyContent: "flex-start",
    width: "auto"
});

const budgetAmountValueStyle = css({
    height: "auto",
    maxWidth: "100%",
    textAlign: "left",
    width: "100%"
});

const financingStyle = css({
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    gap: 1
});

const labelStyle = css({
    whiteSpace: "nowrap"
});

const optionsStyle = css({
    display: "flex",
    flexWrap: "wrap",
    gap: 1
});
